import MainView from "views/MainView";
import {
  Header,
  DataType,
  List,
  PulseEchart,
  BloodPressureEchart,
} from "./components";

import { IUser, IDataRow, IChartList } from "../types";
import { useIntl } from "react-intl";
import { useState, useEffect, useRef } from "react";
import {
  IMeterQueryParams,
  meterShareList,
  meterShareChart,
  queryStrToObject,
} from "request";

export const MeterSharePage = () => {
  const { formatMessage } = useIntl();

  const [dataList, setDataList] = useState<IDataRow[]>([]);
  const [dataType, setDateType] = useState<DataType>("Chart");
  const [chartList, setChartList] = useState<IChartList[]>([]);
  const [user, setUser] = useState<IUser | undefined>(undefined);
  const urlParams = useRef<IMeterQueryParams | null>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const [isMode, setIsMode] = useState<boolean>(false);

  useEffect(() => {
    // 定义处理主题更改的函数
    const handleThemeChange = (event?: any) => {
      // event可能为undefined，因为一开始手动调用时没有event参数
      const isDarkMode = event
        ? event.matches
        : window.matchMedia("(prefers-color-scheme: dark)").matches;
      setIsMode(isDarkMode);
    };

    // 页面加载时判断当前主题
    handleThemeChange();
    // 获取MediaQueryList对象
    const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
    // 监听主题变化
    mediaQueryList.addEventListener("change", handleThemeChange);
    // 组件卸载时移除监听器
    return () => {
      mediaQueryList.removeEventListener("change", handleThemeChange);
    };
    
  }, []); // 确保effect只在组件挂载时运行

  const onGetEchartData = () => {
    meterShareChart({ params: urlParams.current as IMeterQueryParams })
      .then((res: any) => {
        if (res.code === "200") {
          const measures = (res?.result?.measures || []) as IChartList[];
          setChartList(measures);
          setUser(res?.result?.user);

          const index = measures.findIndex(
            (item) => item.sys && item.dia && item.pul
          );
          setActiveIndex(index);
        }
      })
      .catch((err: any) => console.log(err));
  };

  const onGetListData = () => {
    meterShareList({ params: urlParams.current as IMeterQueryParams })
      .then((res: any) => {
        if (res.code === "200") {
          const list = res.result.measures as IDataRow[];
          setDataList(list);
        }
      })
      .catch((err: any) => console.log(err));
  };

  const onChange = (index: number) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    const queryParamsResult = queryStrToObject();
    urlParams.current = queryParamsResult as unknown as IMeterQueryParams;
    onGetEchartData();
    onGetListData();
  }, []);

  return (
    <MainView
      backgroundClassName="bg-[#e4f0ef] dark:bg-black1b1f1e pt-3"
      title={formatMessage({
        id: "meter.share.title",
      })}
    >
      <Header
        user={user}
        dataType={dataType}
        onChange={(dataType) => setDateType(dataType)}
      />
      {dataType === "Chart" && (
        <div className="mt-[-53px] mx-[12px] pb-8 flex flex-col xl:flex-row items-center justify-evenly flex-wrap gap-9 md:gap-[56px] lg:flex-row xl:mx-64px xl:mt-[66px]">
          <BloodPressureEchart
            activeIndex={activeIndex}
            chartList={chartList}
            isMode={isMode}
            onChange={onChange}
          />
          <PulseEchart
            activeIndex={activeIndex}
            chartList={chartList}
            isMode={isMode}
            onChange={onChange}
          />
        </div>
      )}
      {dataType === "List" && (
        <div className="mt-[-62px] mx-[12px] pb-3 md:mx-10 xl:mt-2">
          <List dataList={dataList} />
        </div>
      )}
    </MainView>
  );
};
